import { requestREST } from "~/client/http/CommonHTTP";

export interface GetDealersParams {
  dealerSearch?: {
    ids?: number[];
    code?: string;
    dealerName?: string;
    address?: string;
    city?: string;
    status?: string;
    inn?: string;
    category?: string;
  };
  status?: string[];
  categories?: string[];
  dealerTypes?: string[];
  inn?: string;
  code?: string;
  kgaCode?: string;
  country?: string[];
  fo?: string[];
  subject?: string[];
  city?: string[];
  isNewDealer?: boolean;
  isTerminated?: boolean;
  page?: number;
  count?: number;
  isAll?: boolean;
  extendedForNextYear?: boolean;
}

export interface DealerItem {
  id: number;
  type: string;
  dealerName: string;
  tradeDealerName: string;
  legalDealerName: string;
  inn: string;
  code: string;
  kgaCode: string;
  birCode: string;
  vazCode: string;
  status: string;
  category: string;
  dealerType: string;
  country: string;
  fo: string;
  subject: string;
  city: string;
  reestrAddress: string;
  corporateEmail: string;
  newDealer: number;
  terminated: number;
  extendedForNextYear: number;
  hideOnLadaRu: number;
  xShopFlag: boolean;
  contractEndDate: string;
  createdAt: string;
  updatedAt: string;
  headName: string;
  headPhone: string;
  headEmail: string;
  ownerName: string;
  ivideonOwnerName: string;
  holdingName: string;
  ladaBusiness: boolean;
  ladaSport: boolean;
  checkStatus: boolean;
  cameras: {
    total: number;
    serviceCameras: number;
    saleCameras: number;
    serviceCheck: boolean;
    saleCheck: boolean;
  };
  groups: {
    id: string;
    name: string;
    isAcceptance: boolean;
    camerasCount: number;
    ownerName: string;
  }[];
}

export interface GetDealersResponse {
  dealers: DealerItem[];
  totalCount: number;
  page: number;
  count: number;
  totalPages: number;
}

export async function getDataIvideon(
  sort: string,
  count: any,
  page: any,
): Promise<GetDealersResponse> {
  const params = new URLSearchParams(sort || "");
  params.set("count", count ? count.toString() : "25");
  params.set("page", page ? page.toString() : "0");

  const { data } = await requestREST.get<GetDealersResponse>(
    `/dealer/dealers?${params.toString()}`,
  );
  return data;
}
